import { getInputMethodFromEvent } from "@1js/acui-common";
import { useCallback } from "react";
import type { AppGalleryButtonProps } from "../components/AppGalleryButton/next/AppGalleryButton.type";
export const useOnExecute = (props: AppGalleryButtonProps) => {
  return useCallback(
    (ev: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
      if (!props.disabled && props.onExecute) {
        props.onExecute({
          galleryButton: props,
          location: props.location,
          inputMethod: getInputMethodFromEvent(ev),
          shouldTakeFocus: props.shouldTakeFocus,
          triggerTime: ev && ev.timeStamp,
          event: ev?.nativeEvent,
          terminalParentControlId: props.terminalParentControlId,
        });
      }
    },
    [props]
  );
};
